/* MK — interacciones de las secciones propias */

(function () {
  'use strict';

  /* Compara textos sin acentos ni mayusculas: "Marron" y "marrón" son lo mismo. */
  function normalizar(texto) {
    var t = (texto == null ? '' : String(texto)).toLowerCase();
    if (typeof t.normalize === 'function') {
      t = t.normalize('NFD').replace(/[̀-ͯ]/g, '');
    }
    return t;
  }

  function initReveals() {
    var elementos = document.querySelectorAll('.mk-reveal');
    if (!elementos.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elementos.forEach(function (el) { el.classList.add('mk-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mk-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    elementos.forEach(function (el) { observer.observe(el); });
  }

  function esGaleriaSlideshow(el) {
    return !!(el && el.closest && el.closest('[data-mk-slideshow="true"]'));
  }

  function initGaleriaProducto() {
    var principal = document.querySelector('#mk-foto-principal img');
    var miniaturas = document.querySelectorAll('.mk-prod__miniatura');
    if (!principal || !miniaturas.length) return;

    miniaturas.forEach(function (mini) {
      /* En modo slideshow automático, initSlideshowProducto() es quien
         controla los clicks de las miniaturas (para poder reiniciar el
         temporizador de avance automático). */
      if (esGaleriaSlideshow(mini)) return;

      mini.addEventListener('click', function () {
        principal.removeAttribute('srcset');
        principal.removeAttribute('sizes');
        principal.src = mini.getAttribute('data-mk-img');
        miniaturas.forEach(function (m) { m.classList.remove('mk-prod__miniatura--activa'); });
        mini.classList.add('mk-prod__miniatura--activa');
      });
    });
  }

  /*
    Slideshow del producto.

    Rota SOLO entre las fotos que estan visibles en ese momento. Quien decide
    cuales se ven es initFiltroFotosPorColor(), que esconde las miniaturas que
    no son del color elegido. Asi, al apretar un color el carrusel salta a la
    foto de ese color y sigue girando pero solo con las fotos de ese color.
  */
  function initSlideshowProducto() {
    var galerias = document.querySelectorAll('.mk-prod__galeria[data-mk-slideshow="true"]');
    if (!galerias.length) return;

    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('#mk-foto-principal img, .mk-prod__foto-principal img');
      var tiraMinis = galeria.querySelector('.mk-prod__miniaturas');
      var todas = Array.from(galeria.querySelectorAll('.mk-prod__miniatura'));
      if (!principal || !todas.length) return;

      var velocidad = parseInt(galeria.getAttribute('data-mk-slideshow-velocidad'), 10);
      if (!velocidad || velocidad < 1) velocidad = 4;

      var indice = 0;
      var timer = null;
      var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Las miniaturas que el filtro por color dejo a la vista. Si el filtro
         escondio todas (producto sin fotos etiquetadas), se usan todas para no
         dejar la galeria vacia. */
      function visibles() {
        var lista = todas.filter(function (m) { return m.style.display !== 'none'; });
        return lista.length ? lista : todas;
      }

      /*
        En celular no tiene sentido bajar la foto de 1400px: se pide al CDN
        de Shopify el ancho que realmente entra en la pantalla. Menos datos
        y cambios de foto más rápidos con datos móviles.
      */
      function urlParaPantalla(url) {
        if (!url) return url;
        var ancho = window.innerWidth || 900;
        var densidad = Math.min(window.devicePixelRatio || 1, 2);
        var objetivo = Math.round(ancho * densidad);
        if (objetivo < 600) objetivo = 600;
        if (objetivo > 1400) objetivo = 1400;
        return url.replace(/([?&]width=)\d+/, '$1' + objetivo);
      }

      function centrarMiniatura(mini) {
        if (!tiraMinis || !mini) return;
        if (tiraMinis.scrollWidth <= tiraMinis.clientWidth + 4) return;
        var caja = tiraMinis.getBoundingClientRect();
        var cajaMini = mini.getBoundingClientRect();
        var desplazamiento = (cajaMini.left + cajaMini.width / 2) - (caja.left + caja.width / 2);
        if (Math.abs(desplazamiento) < 2) return;
        if (typeof tiraMinis.scrollBy === 'function') {
          tiraMinis.scrollBy({ left: desplazamiento, behavior: reducido ? 'auto' : 'smooth' });
        } else {
          tiraMinis.scrollLeft += desplazamiento;
        }
      }

      function aplicar(url) {
        principal.removeAttribute('srcset');
        principal.removeAttribute('sizes');
        principal.src = url;
        principal.classList.remove('mk-prod__foto--entra');
        /* fuerza el reinicio de la animación */
        void principal.offsetWidth;
        principal.classList.add('mk-prod__foto--entra');
      }

      function mostrar(i) {
        var lista = visibles();
        if (!lista.length) return;
        if (i < 0) i = lista.length - 1;
        if (i >= lista.length) i = 0;
        indice = i;

        var mini = lista[i];
        if (!mini) return;

        todas.forEach(function (m) { m.classList.remove('mk-prod__miniatura--activa'); });
        mini.classList.add('mk-prod__miniatura--activa');
        centrarMiniatura(mini);

        var url = urlParaPantalla(mini.getAttribute('data-mk-img'));
        /* Se precarga antes de cambiar el src: así nunca se ve un hueco
           blanco mientras baja la foto (clave con datos móviles lentos). */
        var previa = new Image();
        previa.onload = function () { aplicar(url); };
        previa.onerror = function () { aplicar(url); };
        previa.src = url;

        /* Deja lista también la siguiente foto. */
        var siguienteMini = lista[(i + 1) % lista.length];
        if (siguienteMini && siguienteMini !== mini) {
          var adelanto = new Image();
          adelanto.src = urlParaPantalla(siguienteMini.getAttribute('data-mk-img'));
        }
      }

      function siguiente() { mostrar(indice + 1); }
      function anterior() { mostrar(indice - 1); }

      function iniciar() {
        detener();
        if (reducido || document.hidden) return;
        /* Con una sola foto visible no hay nada que rotar. */
        if (visibles().length < 2) return;
        timer = window.setInterval(siguiente, velocidad * 1000);
      }

      function detener() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      todas.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var i = visibles().indexOf(mini);
          if (i < 0) return;
          mostrar(i);
          iniciar();
        });
      });

      /*
        Al elegir un color: el filtro ya escondio las fotos de los otros colores
        y initVariantesProducto ya dejo el id de la variante actualizado, asi que
        aca solo hay que saltar a la foto de esa variante y volver a arrancar el
        temporizador con la lista nueva.
      */
      function fotoDeLaVarianteElegida(lista) {
        var campo = document.getElementById('mk-variant-id');
        var datos = document.getElementById('mk-variantes-data');
        if (!campo || !datos) return -1;
        var variantes;
        try {
          variantes = JSON.parse(datos.textContent);
        } catch (e) {
          return -1;
        }
        var actual = variantes.find(function (v) {
          return String(v.id) === String(campo.value);
        });
        if (!actual || !actual.imagen) return -1;
        var base = actual.imagen.split('?')[0];
        return lista.findIndex(function (mini) {
          return (mini.getAttribute('data-mk-img') || '').split('?')[0] === base;
        });
      }

      var opcionesEl = document.getElementById('mk-opciones');
      if (opcionesEl) {
        opcionesEl.addEventListener('change', function () {
          var lista = visibles();
          if (!lista.length) return;
          var objetivo = fotoDeLaVarianteElegida(lista);
          mostrar(objetivo >= 0 ? objetivo : 0);
          iniciar();
        });
      }

      /* Celular: se puede pasar las fotos deslizando con el dedo. */
      var toqueX = null;
      var toqueY = null;
      galeria.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        toqueX = e.touches[0].clientX;
        toqueY = e.touches[0].clientY;
        detener();
      }, { passive: true });

      galeria.addEventListener('touchend', function (e) {
        if (toqueX === null || !e.changedTouches || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - toqueX;
        var dy = e.changedTouches[0].clientY - toqueY;
        toqueX = null;
        toqueY = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) { siguiente(); } else { anterior(); }
        }
        iniciar();
      }, { passive: true });

      galeria.addEventListener('touchcancel', function () {
        toqueX = null;
        toqueY = null;
        iniciar();
      }, { passive: true });

      /* Escritorio: pausa mientras el mouse está sobre la foto. */
      galeria.addEventListener('mouseenter', detener);
      galeria.addEventListener('mouseleave', iniciar);

      /* No gasta datos ni batería con la pestaña en segundo plano. */
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { detener(); } else { iniciar(); }
      });

      /* Arranque: si la foto que dejo el servidor sigue visible se respeta;
         si el filtro por color la escondio, se muestra la primera que quedo. */
      var listaInicial = visibles();
      var activa = listaInicial.findIndex(function (m) {
        return m.classList.contains('mk-prod__miniatura--activa');
      });
      if (activa >= 0) {
        indice = activa;
      } else {
        mostrar(0);
      }

      iniciar();
    });
  }

  function initVariantesProducto() {
    var dataEl = document.getElementById('mk-variantes-data');
    var opciones = document.getElementById('mk-opciones');
    if (!dataEl || !opciones) return;

    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var inputId = document.getElementById('mk-variant-id');
    var precio = document.getElementById('mk-precio');
    var precioAntes = document.getElementById('mk-precio-antes');
    var precioTransfer = document.getElementById('mk-precio-transfer');
    var boton = document.getElementById('mk-btn-comprar');
    var fotoPrincipal = document.querySelector('#mk-foto-principal img');
    var fotoEsSlideshow = esGaleriaSlideshow(fotoPrincipal);
    var stickyBoton = document.getElementById('mk-sticky-boton');
    var stickyPrecio = document.getElementById('mk-sticky-precio');

    /*
      Boton "Comprar ahora". El servidor ya lo dibuja con el texto de agotado
      cuando la variante inicial no tiene stock, pero al cambiar de color o de
      talle hay que actualizarlo igual que al boton principal: antes se quedaba
      diciendo "Comprar ahora" al lado de otro que decia "SIN STOCK".
    */
    var botonRapido = document.getElementById('mk-btn-rapido');
    var textoRapidoDisponible = botonRapido
      ? (botonRapido.getAttribute('data-mk-disponible') || 'Comprar ahora')
      : '';

    /*
      Aviso de unidades restantes. Antes se dibujaba una sola vez al cargar la
      pagina y no se tocaba nunca mas, asi que al cambiar de color seguia
      mostrando el stock del color inicial. Ahora se recalcula en cada cambio
      a partir del inventario real de la variante elegida.
    */
    var stockCaja = document.getElementById('mk-stock');
    var stockTexto = document.getElementById('mk-stock-texto');
    var stockActivo = !!stockCaja && stockCaja.getAttribute('data-mk-stock-activo') === 'true';
    var stockUmbral = stockCaja ? parseInt(stockCaja.getAttribute('data-mk-stock-umbral'), 10) : 0;
    var stockDetalle = stockCaja ? (stockCaja.getAttribute('data-mk-stock-detalle') || '') : '';
    if (!stockUmbral || stockUmbral < 0) stockUmbral = 0;

    function actualizarStock(variante) {
      if (!stockCaja || !stockTexto) return;

      var cantidad = variante && typeof variante.inventario === 'number' ? variante.inventario : 0;
      var mostrar =
        stockActivo &&
        !!variante &&
        variante.disponible === true &&
        variante.controla_stock === true &&
        cantidad > 0 &&
        cantidad <= stockUmbral;

      if (!mostrar) {
        stockCaja.hidden = true;
        stockTexto.textContent = '';
        return;
      }

      stockTexto.textContent =
        (cantidad === 1 ? 'Queda 1 unidad' : 'Quedan ' + cantidad + ' unidades') + stockDetalle;
      stockCaja.hidden = false;
    }

    /* Texto "sin stock": siempre desde el atributo del boton. */
    var textoAgotado = boton ? (boton.getAttribute('data-mk-agotado') || 'SIN STOCK') : '';

    /*
      Texto "disponible": si la pagina cargo con una variante SIN stock (por ejemplo
      con ?variant=... en el enlace), el texto inicial del boton es el de agotado.
      Antes se guardaba ese texto como texto base y el boton quedaba diciendo
      "Agotado" para siempre, incluso al elegir un talle/color CON stock.
      Por eso solo se usa el texto inicial cuando el boton arranca habilitado.
    */
    var textoDisponible = '';
    if (boton) {
      var textoInicial = boton.textContent.trim();
      if (!boton.disabled && textoInicial && textoInicial !== textoAgotado) {
        textoDisponible = textoInicial;
      } else {
        textoDisponible = boton.getAttribute('data-mk-disponible') || 'Agregar al carrito';
      }
    }

    function sincronizarSticky() {
      if (stickyBoton && boton) {
        stickyBoton.disabled = boton.disabled;
        stickyBoton.textContent = boton.textContent.trim();
      }
      if (stickyPrecio && precio) stickyPrecio.textContent = precio.textContent.trim();
    }

    function actualizarBotonRapido(disponible) {
      if (!botonRapido) return;
      botonRapido.disabled = !disponible;
      botonRapido.textContent = disponible ? textoRapidoDisponible : textoAgotado;
    }

    function actualizarDisponibilidadOpciones(sel) {
      var fieldsets = Array.from(opciones.querySelectorAll('fieldset'));
      var indiceColor = fieldsets.findIndex(function (fieldset) {
        return fieldset.hasAttribute('data-mk-color-opcion');
      });
      var colorElegido = indiceColor >= 0 ? sel[indiceColor] : null;

      fieldsets.forEach(function (fieldset, indice) {
        fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var posible = variantes.some(function (variante) {
            if (!variante.disponible || variante.opciones[indice] !== input.value) return false;
            if (indice === indiceColor || indiceColor < 0) return true;
            return variante.opciones[indiceColor] === colorElegido;
          });
          input.disabled = !posible;
          var pill = input.closest('.mk-prod__pill');
          if (pill) pill.classList.toggle('mk-prod__pill--agotada', !posible);
        });
      });
    }

    function ajustarCombinacionAlCambiarColor(input) {
      var fieldset = input.closest('[data-mk-color-opcion]');
      if (!fieldset) return;
      var fieldsets = Array.from(opciones.querySelectorAll('fieldset'));
      var indiceColor = fieldsets.indexOf(fieldset);
      var disponible = variantes.find(function (variante) {
        return variante.disponible && variante.opciones[indiceColor] === input.value;
      });
      if (!disponible) return;

      fieldsets.forEach(function (fs, indice) {
        if (indice === indiceColor) return;
        var radio = Array.from(fs.querySelectorAll('input[type="radio"]')).find(function (candidate) {
          return candidate.value === disponible.opciones[indice];
        });
        if (radio) radio.checked = true;
      });
    }

    function seleccionadas() {
      var valores = [];
      opciones.querySelectorAll('fieldset').forEach(function (fs) {
        var marcado = fs.querySelector('input:checked');
        valores.push(marcado ? marcado.value : null);
      });
      return valores;
    }

    function actualizar() {
      var sel = seleccionadas();
      actualizarDisponibilidadOpciones(sel);
      var variante = variantes.find(function (v) {
        return v.opciones.every(function (op, i) { return op === sel[i]; });
      });

      /* Combinacion que no existe como variante: tampoco se puede comprar. */
      if (!variante) {
        if (boton) {
          boton.disabled = true;
          boton.textContent = textoAgotado;
        }
        actualizarBotonRapido(false);
        actualizarStock(null);
        sincronizarSticky();
        return;
      }

      if (inputId) inputId.value = variante.id;
      if (precio) precio.textContent = variante.precio;
      if (precioAntes) {
        precioAntes.style.display = variante.precio_antes ? '' : 'none';
        if (variante.precio_antes) precioAntes.textContent = variante.precio_antes;
      }
      if (precioTransfer && variante.precio_transferencia) {
        precioTransfer.textContent = variante.precio_transferencia;
      }
      if (boton) {
        boton.disabled = !variante.disponible;
        boton.textContent = variante.disponible ? textoDisponible : textoAgotado;
      }
      actualizarBotonRapido(variante.disponible === true);
      actualizarStock(variante);
      /* En modo slideshow la foto la maneja initSlideshowProducto(), que salta
         a la foto del color y sigue rotando solo con las de ese color. */
      if (fotoPrincipal && variante.imagen && !fotoEsSlideshow) {
        fotoPrincipal.removeAttribute('srcset');
        fotoPrincipal.removeAttribute('sizes');
        fotoPrincipal.src = variante.imagen;
        var base = variante.imagen.split('?')[0];
        document.querySelectorAll('.mk-prod__miniatura').forEach(function (mini) {
          var miniBase = (mini.getAttribute('data-mk-img') || '').split('?')[0];
          mini.classList.toggle('mk-prod__miniatura--activa', miniBase === base);
        });
      }
      sincronizarSticky();
    }

    opciones.addEventListener('change', function (event) {
      if (event.target && event.target.matches('input[type="radio"]')) {
        ajustarCombinacionAlCambiarColor(event.target);
      }
      actualizar();
    });
    actualizar();
  }

  function initGuiaModal() {
    var abrir = document.getElementById('mk-guia-abrir');
    var modal = document.getElementById('mk-guia-modal');
    if (!abrir || !modal) return;

    function abrirModal() {
      modal.hidden = false;
      document.body.classList.add('mk-guia-open');
    }
    function cerrarModal() {
      modal.hidden = true;
      document.body.classList.remove('mk-guia-open');
    }

    abrir.addEventListener('click', abrirModal);
    modal.querySelectorAll('[data-mk-guia-cerrar]').forEach(function (el) {
      el.addEventListener('click', cerrarModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) cerrarModal();
    });
  }

  /*
    Filtro de fotos por color.

    Una foto es "de un color" si su texto alternativo NOMBRA ese color
    ("...Prelavada marron de perfil..." es del marron). Antes se exigia que el
    texto alternativo fuera exactamente el nombre del color, y como los textos
    son descriptivos no coincidia ninguno: la galeria se quedaba sin miniaturas.

    Una foto que no nombra ningun color del producto (un detalle del bordado,
    la etiqueta) se considera neutra y se muestra siempre.
  */
  function initFiltroFotosPorColor() {
    var dataEl = document.getElementById('mk-media-colores');
    var opciones = document.getElementById('mk-opciones');
    var miniaturas = Array.from(document.querySelectorAll('.mk-prod__miniatura'));
    var contenedor = document.querySelector('.mk-prod__miniaturas');
    if (!dataEl || !opciones || !miniaturas.length) return;

    var mapa;
    try {
      mapa = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var fieldsetColor = opciones.querySelector('[data-mk-color-opcion]');
    if (!fieldsetColor) return;

    var coloresDelProducto = Array.from(fieldsetColor.querySelectorAll('input[type="radio"]'))
      .map(function (input) { return normalizar(input.value); })
      .filter(Boolean);

    function textoDe(id) {
      var partes = mapa[id] || [];
      return normalizar(partes.join(' '));
    }

    function esDelColor(id, color) {
      if (!color) return false;
      return textoDe(id).indexOf(color) !== -1;
    }

    function esNeutra(id) {
      var texto = textoDe(id);
      if (!texto) return true;
      return !coloresDelProducto.some(function (c) { return texto.indexOf(c) !== -1; });
    }

    function colorSeleccionado() {
      var marcado = fieldsetColor.querySelector('input:checked');
      return marcado ? normalizar(marcado.value) : null;
    }

    function aplicarFiltro() {
      var color = colorSeleccionado();
      if (!color) return;

      var propias = miniaturas.filter(function (mini) {
        return esDelColor(mini.getAttribute('data-mk-media-id'), color);
      });
      /* Ninguna foto etiquetada con este color: se muestran todas antes que
         dejar la galeria vacia. */
      var mostrarTodas = propias.length === 0;

      var visibles = 0;
      miniaturas.forEach(function (mini) {
        var id = mini.getAttribute('data-mk-media-id');
        var ver = mostrarTodas || esDelColor(id, color) || esNeutra(id);
        mini.style.display = ver ? '' : 'none';
        if (ver) visibles++;
      });

      if (contenedor) {
        contenedor.style.display = visibles > 1 ? '' : 'none';
      }
    }

    opciones.addEventListener('change', aplicarFiltro);
    aplicarFiltro();
  }

  function initStickyCompra() {
    var sticky = document.getElementById('mk-prod-sticky');
    var stickyBoton = document.getElementById('mk-sticky-boton');
    var botonPrincipal = document.getElementById('mk-btn-comprar');
    var producto = document.querySelector('.mk-prod');
    if (!sticky || !stickyBoton || !botonPrincipal || !producto) return;

    stickyBoton.addEventListener('click', function () {
      if (botonPrincipal.disabled) return;
      if (botonPrincipal.form && typeof botonPrincipal.form.requestSubmit === 'function') {
        botonPrincipal.form.requestSubmit(botonPrincipal);
      } else {
        botonPrincipal.click();
      }
    });

    function actualizarVisibilidad() {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      var botonRect = botonPrincipal.getBoundingClientRect();
      var productoRect = producto.getBoundingClientRect();
      var botonVisible = botonRect.top < window.innerHeight && botonRect.bottom > 0;
      var productoVisible = productoRect.top < window.innerHeight && productoRect.bottom > 0;
      var mostrar = mobile && productoVisible && window.scrollY > 240 && !botonVisible;
      sticky.classList.toggle('is-visible', mostrar);
    }

    window.addEventListener('scroll', actualizarVisibilidad, { passive: true });
    window.addEventListener('resize', actualizarVisibilidad);
    actualizarVisibilidad();
  }

  /*
    El orden importa: primero el filtro decide que miniaturas se ven, despues
    initVariantesProducto deja el id de la variante actualizado, y recien
    entonces el slideshow salta a la foto correcta con la lista ya filtrada.
  */
  function initTodo() {
    initReveals();
    initGaleriaProducto();
    initFiltroFotosPorColor();
    initVariantesProducto();
    initSlideshowProducto();
    initGuiaModal();
    initStickyCompra();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }
})();
